import { Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'lsz-binary-select',
  templateUrl: './binary-select.component.html',
  styleUrls: ['./binary-select.component.css'],
})
export class BinarySelectComponent {
  @Input() public form: UntypedFormGroup;
  @Input() public name: string;
  public iconNo: unknown;
  public iconYes: unknown;

  constructor() {
    this.iconNo = faTimes;
    this.iconYes = faCheck;
  }
}
